// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"PropertyBlockLabel__tooltip__89r46","popover":"PropertyBlockLabel__popover__3R-79"};